import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import MediaSection from '@/pages/home/components/MediaSection';
import IndexSection from '@/pages/home/components/IndexSection';
import AppSection from '@/pages/home/components/AppSection';
import CardsSection from '@/pages/home/components/CardsSection';
import AboutSection from '@/pages/home/components/AboutSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import FAQSection from '@/pages/home/components/FAQSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import RankingSection from '@/pages/home/components/RankingSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import ContactSection from '@/pages/home/components/ContactSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <CommentsSection />
        <MediaSection />
        <IndexSection />
        <AppSection />
        <CardsSection />
        <AboutSection />
        <TopicsSection />
        <FAQSection />
        <UpdatesSection />
        <RankingSection />
        <FeaturesSection />
        <CarouselSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}